/**
 * @Author: wuyang
 * @Date: 2024/1/30
 * @Description: ""
 */
import { atomWithQuery, AtomWithQueryOptions } from 'jotai-tanstack-query'
import { getTask, getTaskList } from '@/api/task'
import { EBizPhone } from '@/types/bizPhone'
import { getFollowImageList } from '@/api/image'
import { ITaskListItem } from '@/types/task'

/**
 * 任务列表
 * @param type
 */
export const getTaskListQuery = (type: EBizPhone) =>
	atomWithQuery((get) => {
		const queryClientOptions: AtomWithQueryOptions<ITaskListItem[]> = {
			queryKey: ['task-list', type],
			staleTime: 0,
			queryFn: () => {
				return getTaskList({
					type
				}).fire()
			}
		}
		return queryClientOptions
	})

/**
 * 任务详情
 * @param taskId
 */
export const getTaskQuery = (taskId: string) =>
	atomWithQuery((get) => {
		const queryClient: AtomWithQueryOptions = {
			queryKey: ['task', taskId],
			queryFn: () => {
				return getTask(taskId).fire()

				//return getTask(taskId,2).fire()
			}
		}
		return queryClient
	})

/**
 * 获取收藏列表
 * @param params
 */
export const getFollowImageListQuery = (
	params: Parameters<typeof getFollowImageList>[0]
) => {
	return atomWithQuery((get) => {
		const queryClient: AtomWithQueryOptions = {
			queryKey: ['task', params],
			queryFn: () => {
				return getFollowImageList(params).fire()
			}
		}
		return queryClient
	})
}
